module.exports = __webpack_public_path__ + "static/media/players.81fb989c.png";